import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import loadable from "@loadable/component";

import RootLayout from "../layout/MainLayout";
import SnippetsLayout from "../layout/SnippetsLayout";

const LoadableNotFound = loadable(() => import("../layout/NotFound"));
const LoadableMainSnippetUI = loadable(() =>
  import(
    "../snippet-main-ui/snippet-main-container/SnippetMainContainer"
  )
);
const LoadableColorsToggleButtons = loadable(() =>
  import("@components/filter/ColorsToggleButtonsFilterPalette")
);
const LoadableInfo = loadable(() => import("@components/info/Info"));
const LoadableDesktop = loadable(() =>
  import("@components/desktop/Desktop")
);
const LoadableSettings = loadable(() =>
  import("@components/settings/Settings")
);

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={<RootLayout />}
      errorElement={<LoadableNotFound />}
    >
      <Route index element={<LoadableDesktop />} />
      <Route path="/snippets" element={<SnippetsLayout />}>
        <Route
          path="edit/:snippetIdParam"
          element={<LoadableMainSnippetUI />}
        ></Route>
      </Route>

      <Route
        path="palette"
        element={<LoadableColorsToggleButtons />}
      />
      <Route path="info" element={<LoadableInfo />} />
      <Route path="settings" element={<LoadableSettings />} />
    </Route>
  )
);
